import Cards from "../components/about/Cards";

function About() {
  return <Cards />;
}

export default About;
